export default __webpack_public_path__ + "static/m-portfolio1-a3d8508022cabddaf97facbd7bd1ed4d.jpg";